import { useEffect, useMemo, useState } from "react";
import Select from "react-select";
import { fetchSymbols } from "./Utilities/CoTraderUtils";
import { MultiSelect } from "react-multi-select-component";
import {
  autoScrollSelectComponents,
} from "../Common/SelectMenuScroll";
import { formatCoTraderFilterLabel } from "./TickerUniverseOptions";

const CoTraderFilters = ({
  setSelectedSymbol,
  setUpdateSpeed,
  setTenor,
  tenorList,
  setInstrumentType,
  instrumentType
}) => {
  const [symbols, setSymbols] = useState([]);
  const [selectedSymbol1, setSelectedSymbol1] = useState({
    value: localStorage.getItem("default_symbol") || "USDJPY",
    label: localStorage.getItem("default_symbol") || "USDJPY",
  });
  const [selectedUpdateSpeed, setSelectedUpdateSpeed] = useState({
    value: 2,
    label: "2s",
  });
  const updateSpeed = useMemo(
    () => [
      { value: 2, label: "2s" },
      { value: 3, label: "3s" },
      { value: 5, label: "5s" },
    ],
    [],
  );
  const instrumentOptions = useMemo(
    () => [
      { value: "FX_SPOT", label: "FX SPOT" },
      { value: "FX_FORWARD", label: "FX FORWARD" },
    ],
    [],
  );
  const tenorType = useMemo(() => {
    return tenorList.map((item) => ({
      value: item,
      label: item,
    }));
  }, [tenorList]);
  const [selectedTenor, setSelectedTenor] = useState(
    tenorType.map((item) => item)
  );
  const [isLoading, setIsLoading] = useState(false);
  const selectedInstrumentOption = useMemo(
    () => ({
      value: instrumentType,
      label: formatCoTraderFilterLabel(instrumentType),
    }),
    [instrumentType],
  );
  useEffect(() => {
    fetchSymbols({ setSymbols: setSymbols, setIsLoading: setIsLoading });
  }, []);

  useEffect(() => {
    if (setTenor) {
      setSelectedTenor(tenorType.map((item) => item));
      setTenor(tenorType.map((item) => item.value));
    }
  }, [tenorList]);

  const setSymbol = (symbol) => {
    setSelectedSymbol1(symbol);
    setSelectedSymbol(symbol.value);
    localStorage.setItem("default_symbol", symbol.value);
  };
  const handleUpdateSpeed = (updateSpeed) => {
    setSelectedUpdateSpeed(updateSpeed);
    setUpdateSpeed(updateSpeed.value);
  };

  const handleTenor = (tenor) => {
    setTenor(tenor.map((item) => item.value));
    setSelectedTenor(tenor);
  };
  const customValueRenderer = (selected, _options) => {
    if (selected.length === _options.length) {
      return "All Keywords/Companies";
    } else if (selected.length === 0) {
      setTenor([tenorType[0].value]);
      setSelectedTenor([tenorType[0]]);
      return selected.map(({ label }) => label);
    } else if (selected.length === 1) {
      return selected.map(({ label }) => label);
    } else {
      return selected.map(({ label }) => label).join(", ");
    }
  };
  const selectPortalStyles = {
    control: (base, state) => ({
      ...base,
      minHeight: 44,
      borderRadius: 12,
      borderColor: state.isFocused ? "rgba(13, 110, 253, 0.35)" : "#D8DEE6",
      boxShadow: state.isFocused
        ? "0 0 0 3px rgba(13, 110, 253, 0.08)"
        : "none",
      "&:hover": {
        borderColor: state.isFocused ? "rgba(13, 110, 253, 0.35)" : "#C8D0DA",
      },
    }),
    valueContainer: (base) => ({
      ...base,
      paddingLeft: 10,
      paddingRight: 10,
    }),
    indicatorSeparator: (base) => ({
      ...base,
      backgroundColor: "#E5EAF1",
    }),
    menu: (base) => ({
      ...base,
      borderRadius: 12,
      overflow: "hidden",
      zIndex: 9999,
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  };

  return (
    <div className="w-100 cotrader-filter-bar">
      <style>
        {`
          .cotrader-filter-bar .multi-select .dropdown-container {
            min-height: 44px;
            border: 1px solid #D8DEE6;
            border-radius: 12px;
            background: #FFFFFF;
          }
          .cotrader-filter-bar .multi-select .dropdown-heading {
            min-height: 42px;
            padding: 0 12px;
          }
          .cotrader-filter-bar .multi-select .dropdown-heading-value,
          .cotrader-filter-bar .multi-select .dropdown-heading-dropdown-arrow,
          .cotrader-filter-bar .multi-select .clear-selected-button,
          .cotrader-filter-bar .multi-select .dropdown-content,
          .cotrader-filter-bar .multi-select .select-item,
          .cotrader-filter-bar .multi-select .search input {
            color: #0B1220;
          }
          .cotrader-filter-bar .multi-select .dropdown-content,
          .cotrader-filter-bar .multi-select .panel-content,
          .cotrader-filter-bar .multi-select .select-panel {
            border-radius: 12px;
            border-color: #D8DEE6;
            box-shadow: 0 10px 28px rgba(15, 23, 42, 0.08);
          }
          .cotrader-filter-bar .multi-select .search {
            border-bottom-color: #E5EAF1;
          }
          .cotrader-filter-bar .multi-select .selected-item {
            background: rgba(13, 110, 253, 0.08);
            border-color: rgba(13, 110, 253, 0.12);
          }
        `}
      </style>
      <div className="row g-2 align-items-center w-100">
        <div className="col-12 col-xl-2 col-lg-3 col-md-4">
          <Select
            options={instrumentOptions}
            value={selectedInstrumentOption}
            onChange={(x) => setInstrumentType(x.value)}
            labelledBy={"Select Symbol"}
            isDisabled={isLoading}
            menuPortalTarget={document.body}
            styles={selectPortalStyles}
            components={autoScrollSelectComponents}
          />
        </div>
        <div className="col-12 col-xl-2 col-lg-3 col-md-4">
          <Select
            options={symbols}
            value={selectedSymbol1}
            onChange={(x) => setSymbol(x)}
            labelledBy={"Select Symbol"}
            isDisabled={isLoading}
            menuPortalTarget={document.body}
            styles={selectPortalStyles}
            components={autoScrollSelectComponents}
          />
        </div>

        <div className="col-12 col-xl-1 col-lg-2 col-md-4">
          <Select
            options={updateSpeed}
            value={selectedUpdateSpeed}
            onChange={(x) => handleUpdateSpeed(x)}
            menuPortalTarget={document.body}
            styles={selectPortalStyles}
            components={autoScrollSelectComponents}
          />
        </div>

        {setTenor && (
          <div
            className="col-12 col-xl-2 col-lg-3 col-md-4"
            style={{ zIndex: 999 }}
          >
            {/* react-multi-select-component unfortunately doesn't have menuPortalTarget.
               We'll handle that separately below. */}
            <MultiSelect
              options={tenorType}
              value={selectedTenor || []}
              className="multi-select z-100"
              valueRenderer={customValueRenderer}
              style={{ zIndex: 999 }}
              onChange={handleTenor}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default CoTraderFilters;
